import React from 'react';
import TreeView from 'react-treeview';
import InitiativeParticipationLabel from '../InitiativeParticipationLabel.jsx';

class InitiativeParticipationsTree extends React.Component {
  renderNode = (initiativeParticipation) => {
    const {
      isPreview,
      initiative,
      activeInitiativeParticipationId,
      showSurvey,
      status,
      sentiment,
    } = this.props;

    const nodeLabel = (
      <InitiativeParticipationLabel
        isPreview={isPreview}
        initiative={initiative}
        initiativeParticipation={initiativeParticipation}
        isActive={
          initiativeParticipation.id === activeInitiativeParticipationId
        }
        status={status}
        sentiment={sentiment}
        showCompletionDot={!showSurvey && initiative.completionTracked}
        showSentimentDot={showSurvey}
        showOutlineBox={initiativeParticipation.parentId === null}
        showSurvey={showSurvey}
      />
    );

    if (initiativeParticipation.children.length === 0) {
      return (
        <div key={initiativeParticipation.id} className="tree-view_leaf">
          {nodeLabel}
        </div>
      );
    }

    return (
      <TreeView key={initiativeParticipation.id} nodeLabel={nodeLabel}>
        {initiativeParticipation.children.map(this.renderNode)}
      </TreeView>
    );
  };

  render() {
    const {
      isPreview,
      organization,
      initiative,
      initiativeParticipations,
      activeInitiativeParticipationId,
      showSurvey,
      status,
      sentiment,
    } = this.props;

    const rootNodeLabel = (
      <InitiativeParticipationLabel
        isPreview={isPreview}
        initiative={initiative}
        isActive={activeInitiativeParticipationId === null}
        label={organization.name}
        status={status}
        sentiment={sentiment}
        showOutlineBox
        showSurvey={showSurvey}
      />
    );
    return (
      <TreeView nodeLabel={rootNodeLabel}>
        {initiativeParticipations.map(this.renderNode)}
      </TreeView>
    );
  }
}

export default InitiativeParticipationsTree;
